export const NAV_ITEMS = [
  { name: { it: "Home", en: "Home" }, link: "#", icon: "home" },
  { name: { it: "Progetti", en: "Projects" }, link: "#projects", icon: "layers" },
  { name: { it: "Esperienza", en: "Experience" }, link: "#experience", icon: "briefcase" },
  { name: { it: "Skills", en: "Skills" }, link: "#tech", icon: "cpu" },
];
